export default {
    
    doSetSelectedProduct({ commit }, payload){
        //simulated
        return new Promise((resolve, reject) => {

            commit('setSelectedProduct', payload)
            resolve(payload)

        });   
        
    },
    
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/actions/selectedProductActions.js